import {Component} from '@angular/core';
import {User} from '../../model/user.model';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../state.service';

@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.css'],
    standalone: false
})
export class EditUserComponent {
  user = new User();
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    if (!this.stateService.user) {
      this.router.navigate( ['home']);
    }
    this.user = this.stateService.user;
  }

  onSubmit() {
    this.stateService.editUser(this.user);
    this.submitted = true;
    this.router.navigate( ['user']);
  }

}
